/**
 * Legal-consent constants shared by web + mobile onboarding.
 *
 * TERMS_VERSION identifies which revision of the legal documents the user
 * accepted; it is stamped onto users/{uid} (termsAcceptedAt/termsVersion,
 * dpaAcceptedAt, vendorTermsAcceptedAt) at the consent checkpoints specified
 * by counsel's UX-texts document (signup checkbox, vendor DPA checkbox,
 * vendor commercial-terms checkbox). Bump the version whenever counsel
 * publishes a new revision of the documents at therunup.ai.
 */
export const TERMS_VERSION = "1.0-2026-07-18";

/** Absolute URLs — mobile opens these in the browser; web uses the paths. */
export const LEGAL_URLS = {
  terms: "https://therunup.ai/terms",
  privacy: "https://therunup.ai/privacy",
  dpa: "https://therunup.ai/dpa",
  vendorTerms: "https://therunup.ai/vendor-terms",
} as const;

/** Consent fields stamped at signup (role-selection / signUpUser). */
export function signupConsentFields(now = new Date().toISOString()) {
  return { termsAcceptedAt: now, termsVersion: TERMS_VERSION };
}
